import { render, staticRenderFns } from "./SetupView.vue?vue&type=template&id=950327c8&scoped=true"
import script from "./SetupView.vue?vue&type=script&lang=js"
export * from "./SetupView.vue?vue&type=script&lang=js"
import style0 from "./SetupView.vue?vue&type=style&index=0&id=950327c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950327c8",
  null
  
)

export default component.exports